import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import $myApi from '@/gavnoCode/ApiHandler'
import getAccessArray from '@/gavnoCode/getAccessArray'

Vue.use(VueRouter);


const ifAuthenticated = (to, from, next) => {
    store.dispatch('refLinkSave',{
      pathname: document.location.pathname,
      search: document.location.search,
      fromPath: from.path,
    });
//console.log('test')
  if (store.getters.isAuthenticated) {
  //  console.log('to page')
    next();
    return
  }
 // console.log('to login')
  next('/login');
};
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return
  }
  next('/');
};

const routes = [
  {
    path: '/',
    name: 'Главная',
    component: () => import('@/views/Home'),
    beforeEnter: ifAuthenticated,
    menuView: true,
    sort: 0,
  },
  {
    path: '/oneWindowView',
    name: 'Единое окно',
    component: () => import('@/views/oneWindowView/oneWindowComponent'),
    beforeEnter: ifAuthenticated,
    menuView: true,
    sort: 150,
    accessGroup:[262,281,350,389,713,763,355,757,495,435,425, 365,],
  },
  {
    path: '/login',

    component: () => import('@/views/index'),
    beforeEnter: ifNotAuthenticated,
    props: { id: "loginWrap"},
    children: [
      {path: '',             name: 'login',        component: () => import('@/views/login/LoginForm'),                   },
      {path: 'recovery',     name: 'recovery',     component: () => import('@/views/login/RecoveryPassword'),            },
      {path: 'recoveryFrst', name: 'recoveryFrst', component: () => import('@/views/login/RecoveryPasswordManagerCode'), },
    ]
  },
  {
    path: '/logout',
    name: 'Выход',
    component: () => import('@/views/login/logOut'),
    menuView: true,
    sort: 1000,
    beforeEnter: ifAuthenticated,
  },
  {
    path:'/docs',
    name:'docs',
    menuView:false,
    sort:0,
    component: () => import('@/views/index'),
    children:[
      {path:'iu/:demand',               name:'iu',                    component:()=>import('@/components/documents/iu'),                    props:true},
      {path:'topUpApplication/:demand', name:'topUpApplication',      component:()=>import('@/components/documents/topUpApplication'),      props:true},
      {path:'topUpReceipt/:demand',                                                                                                         props:true},
      {path:'dealAkt/:demand',          name:'dealAct',               component:()=>import('@/components/documents/dealAkt'),               props:true},
      {path:'dealPaySchedule/:demand/:mode',  name:'dealPaySchedule',       component:()=>import('@/components/documents/dealPaySchedule'),       props:true},
      {path:'ConfirmationOfFundsDeposit/:DealID',  name:'ConfirmationOfFundsDeposit',       component:()=>import('@/components/documents/ConfirmationOfFundsDeposit'),       props:true},
      {path:'dealPayScheduleUPR/:demand',  name:'dealPayScheduleUPR',       component:()=>import('@/components/documents/dealPayScheduleUPR'),       props:true},
      {path:'debtReference/:demand',    name:'Справка об отсутствии задолженности ',         component:()=>import('@/components/documents/debtReference'),         props:true},
      {path:'debtReferenceShort/:demand',    name:'Справка об отсутствии задолженности',         component:()=>import('@/components/documents/debtReferenceShort'),         props:true},
      {path:'dealPayBook/:demand',      name:'dealPayBook',           component:()=>import('@/components/documents/dealPayBook'),           props:true},
      {path:'NoticeOfDelay/:demand',    name:'OWDPrintNoticeOfDelay', component:()=>import('@/components/documents/OWDPrintNoticeOfDelay'), props:true}
    ]
  },
  {
    path:'/request',
    name:'Новая заявка',
    menuView:true,
    sort: 50,
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/index'),
    children:[
      {path:'loan',      name:'Заявка на займ',         component:()=>import('@/views/requests/Loan'),      menuView: true,},
      {path:'insurance', name:'Заявка на страхование', component:()=>import('@/views/requests/Insurance'), menuView: true,},
    ]
  },
  { path: '/insurance', redirect: '/request/insurance' },
  {
    path:'/news/list',
    name:'Новости',
     component:()=>import('@/views/index'),
    // component:()=>import('@/views/news/page'),
    beforeEnter: ifAuthenticated,
    children:[
      {path:'/news/list',    name:'Cписок новостей', component:()=>import('@/views/news/page'),      beforeEnter: ifAuthenticated, menuView: false,},
      {path:'/news/:newsid', name:'Новость',         component:()=>import('@/views/news/page_node'), beforeEnter: ifAuthenticated, menuView: false,}
    ],
    //accessGroup:[355],
    menuView: true,
    sort: 20,
  },
  {
    path: '/myRequest',
    name: 'Мои заявки',
    component: () => import('@/views/myRequest/myRequest'),
    beforeEnter: ifAuthenticated,
    menuView: true,
    sort: 90,
    children: [
      {path: 'loan',      name:'Заявки портал',                       component: () => import('@/views/myRequest/myRequestPortal'),    menuView: true, },
      {path: 'lnd',       name:'Заявки реферальная ссылка',           component: () => import('@/views/myRequest/myRequestLnd'),       menuView: true,},
      {path: 'lndShrt',   name:'Заявки(короткие) реферальная ссылка', component: () => import('@/views/myRequest/myRequestLndShrt'),   menuView: false,},
      {path: 'insurance', name:'Заявки страхования',                  component: () => import('@/views/myRequest/myRequestInsurance'), menuView: true, },
    ],
    hideThisFor: ['agentZo']
  },
  // {
  //   path: '/agentCC',
  //   name: 'Исходящий звонок',
  //   component: () => import('@/views/agentCC/agentCC'),
  //   beforeEnter: ifAuthenticated,
  //   menuView: true,
  //   sort: 10,
  //   children:[
  //     {path: '',       component: () => import('@/components/agentCC/list'),  name: 'Исходящий звонок', menuView: false,},
  //     {path: 'detail', component: () => import('@/components/agentCC/detailClient'),                    menuView: false,},
  //   ],
  //   accessGroup: [355,713,763,389,281,350,262,343],
  //   hideThisFor: ['masterZo']
  // },
  {
    path: '/hls',
    name:'dashStream',
    component: ()=> import('@/views/stream/hls'),
    beforeEnter: ifAuthenticated,
  },
  {
    path:'/marketing',
    name:'Маркетинг',
    component:()=>import('@/views/index'),
    beforeEnter: ifAuthenticated,
    children:[
      // {path: 'lndCC', name:'Отчет лендинг партнеры КЦ', component: () => import('@/views/marketing/lndCC'), menuView: true,},
      {path: 'ptInfo', name:'Отчет партнеры', component: () => import('@/views/marketing/ptInfo.vue'), menuView: true,},
    ],
    accessGroup:[355, 365, 111],
    menuView: true,
    sort: 110,
  },
  {
    path: '/menupage',
    name: 'menupage',
    component: () => import('@/views/menuPage'),
    beforeEnter: ifAuthenticated,
  },
  {
    path:'/supervisor',
    name:'Cупервайзер',
    component:()=>import('@/views/index'),
    children:[
      {path:'rpk',name:'Списки РПК',component:()=>import('@/views/supervisor/rpk'),menuView: true,}
    ],
    beforeEnter: ifAuthenticated,
    accessGroup:[355,262,281, 365,],
    hideThisFor: ['masterZo'],
    menuView: true,
    sort: 120,
  },
  {
    path:'/requestConfirm',
    name:'Оформление займа',
    component:()=>import('@/views/requestConfirm/requestRouting'),
    children:[
      {path:'list', name:'Список менеджер оповещен', component:()=>import('@/views/requestConfirm/requestList'),menuView:true,
        hideThisFor: ['masterZo'],
      },
      {path:'terminal',                    name:'Рабочее окно',                      component:()=>import('@/views/requestConfirm/workTerminal'),                 menuView:true  },
      {path:'ConfirmationOfIssue/:demand', name:'Подтверждение выдачи на 25 недель', component:()=>import('@/views/requestConfirm/terminal/ConfirmationOfIssue'), menuView:false },
      {path:'myList',                      name:'Заявки в работе',                   component:()=>import('@/views/requestConfirm/requestListSave'),              menuView:true  },
      {path:'demand/:demand',              name:'Заявка',                            component:()=>import('@/views/requestConfirm/requestDemandEdit'),            menuView:false, props: true},
      {path:'income',                      name:'Прием заявки от КЦ',                component:()=>import('@/views/requestConfirm/requestCCincome'),              menuView:true  },
      {path:'VideoDemand',                      name:'Видео пулл, новые заявки',                component:()=>import('@/views/requestConfirm/video/demVideoNewParent.vue'),              menuView:true  },
      {path:'demRegistration',                      name:'Видео, оформление займа',                component:()=>import('@/views/requestConfirm/video/demRegParent'),
        menuView:true,
        hideThisFor: ['masterZo'],
      },
      {path:'briefcase',                      name:'Видео, портфель',                component:()=>import('@/views/requestConfirm/video/demBriefcaseParent'),              menuView:true,
        hideThisFor: ['masterZo'],
      },
    ],
    beforeEnter: ifAuthenticated,
    menuView: true,
    sort: 130,
    accessGroup: [355,713,763,389,281,350,262,343, 365,]
  },
  {
    path:'/alfa',
    name:'Выдача карт Альфа Банка',
    component:()=>import('@/views/alfa/alfaRouting'),
    children:[
      {path:'alfaFaq',               name:'Вопрос/ответ',             component:()=>import('@/views/alfa/faq'),menuView: true,},
      {path:'alfaRequest',           name:'Новая заявка Альфа карты', component:()=>import('@/views/alfa/alfaNewRequest'),menuView: true,},
      //{path:'newAlfa',             name:'Новая заявка альфа карты', component:()=>import('@/views/alfa/alfaRequestNew'),menuView: false,},
      //{path:'alfaRequest/:demand', name:'заявка альфа карты',       component:()=>import('@/views/alfa/alfaRequestProgress'),menuView: false,},
      {path:'alfaList',              name:'Заявки Альфа в работе',    component:()=>import('@/views/alfa/alfaList'),menuView: true,},
      {
        path:'alfaListStaffing/creditCard',
        name:'Cписок заявок Альфа, кредитная карта',
        component:()=>import('@/views/alfa/alfaGridStaffing'),
        menuView: true,
        sort: 140,
        accessGroup:[355,262,281,350,389,713,714,763, 365,],
      },
      {
        path:'alfaListStaffing/debitCard',
        name:'Cписок заявок Альфа, дебетовая карта',
        component:()=>import('@/views/alfa/alfaGridStaffingDebet'),
        menuView: true,
        sort: 150,
        accessGroup:[355,262,281,350,389,713,714,763, 365,],
      },
    ],
    beforeEnter: ifAuthenticated,
    menuView: false,
    sort: 160,
  },
  {
    path:'/bankCard',
    name:'Партнёрский канал',
    component:()=>import('@/views/index'),
    children:[
          // {
          //   path:'',
          //   name:'Оформить заявку на кредитную карту, Банк Ренессанс Кредит',
          //   // name:'Оформить заявку на кредитную (дебетовую) карту, Банк Ренессанс Кредит',
          //   component:()=>import('@/views/bankCard/renesans/newCard'),
          //   menuView: true,
          //   accessGroup:[0]
          // },
      {
        path:'report',
        name:'Отчет по заявкам',
        component:()=>import('@/views/bankCard/report'),
        menuView: true,
        // accessGroup:[355,262,281,350,389,713,714,763,592,273],
      }
    ],
    menuView: true,
    hideThisFor: ['masterZo'],
    sort:160,
  },
  {
    path:'/motivation',
    name:'Мотивация',
    component:()=>import('@/views/motivation/motivation'),
    children:[
      {path:'agentMotivation',            name:'Отчет агента за неделю',                         component:()=>import('@/views/motivation/weekReport'),                  menuView: true,},
      {path:'RewardForCollected',         name:'Детализация вознаграждения за сборы',            component:()=>import('@/views/motivation/RewardForCollected'),          menuView: true,},
      {path:'RewardForSales',             name:'Детализация вознаграждения за продажи',          component:()=>import('@/views/motivation/RewardForSales'),              menuView: true,},
      {path:'RewardForCustomerAttraction',name:'Детализация вознаграждения за ПК',               component:()=>import('@/views/motivation/RewardForCustomerAttraction'), menuView: true,},
      {path:'RewardForBoxes',             name:'Детализация вознаграждения за доп.продукты',     component:()=>import('@/views/motivation/RewardForBoxes'),              menuView: true,},
      {path:'DealReward',                 name:'Поиск оплаты вознаграждения по номеру договора', component:()=>import('@/views/motivation/DealReward'),                  menuView: true,},
      {path:'KgList',                     name:'Портфель текущей недели',                        component:()=>import('@/views/motivation/KgList'),                      menuView: true,},
      // {path:'AlfaList', name:'Вознаграждение за карты Банка', component:()=>import('@/views/motivation/alfalist'),menuView: false,},
      // {path:'AlfaFinder', name:'Поиск информации по карте Банка', component:()=>import('@/views/motivation/AlfaFinder'),menuView: false,},
      {path:'bankReport', name:'Поиск информации по карте Банка', component:()=>import('@/views/motivation/bankReport'),menuView: true,},
    ],
    beforeEnter: ifAuthenticated,
    menuView: true,

    hideThisFor: ['masterZo','agentZo'],
    sort: 170,
  },
  {
    path:'/motivationRepots',
    name:'Мотивация отчеты',
    component:()=>import('@/views/motivationReports/MotivationReports'),
    beforeEnter: ifAuthenticated,
    menuView: true,
    accessGroup:[355,592, 365,],
    sort: 175,
  },
  {
    name:'testComponents',
    path:'/testComponents',
    component:()=>import('@/views/devTestComponents/ship'),
  },
  {
    name: 'Журналы',
    path: '/grid',
    menuView: true,
    sort: 180,
    children: [
      {name: 'Реферальные ссылки',     path:'refLinksGreed',    component:()=>import('@/views/grid/refLinkGreed.vue'),    menuView: true, accessGroup: [355,713,763,389,281,350,262,99,757,343,495, 365], hideThisFor: ['masterZo', 'agentZo'] },
      {name: 'Контроль оригиналов',     path:'originalsCheck',    component:()=>import('@/views/grid/originalsCheck'),    menuView: true, accessGroup: [355,713,763,389,281,350,262,99,757,495, 365], hideThisFor: ['masterZo', 'agentZo']},
      {name: 'Платежи',     path:'payment',    component:()=>import('@/views/grid/payment'),    menuView: true,accessGroup: [355,713,763,389,281,350,262,757,827,495,435,425, 365], hideThisFor: ['agentZo']},
      {name: 'Заявки',      path:'demandList', component:()=>import('@/views/grid/demandList'), menuView: true,accessGroup: [355,713,763,389,281,350,262,99,757,827,495,823,272,435, 365], hideThisFor: ['agentZo']},
      {name: 'Договора',    path:'deal',       component:()=>import('@/views/grid/deal'),       menuView: true,accessGroup: [355,713,763,389,281,350,262,99,757,827,495,309,273,435, 365], hideThisFor: ['agentZo']},
      {name: 'Организации', path: 'org',       component:()=>import('@/views/grid/org'),        menuView: true, hideThisFor: ['masterZo', 'agentZo']},
      {name: 'Сотрудники', path:'employee', component:()=>import('@/views/grid/employee'), menuView:true,accessGroup:[355,763,713,389,350,262,281,757,495,435, 365], hideThisFor: ['agentZo']},
      {name: 'Листы сбора', path:'collectionList', component:()=>import('@/views/grid/collectionList'), menuView:true,accessGroup:[355,763,713,389,350,262,281,757,827,495, 365], hideThisFor: ['agentZo']},
      {name: 'Листы сбора PDL',     path:'PDL_list',    component:()=>import('@/views/grid/PDL_list'),    menuView: true, accessGroup: [355,713,763,389,281,350,262,757,495, 365], hideThisFor: ['masterZo', 'agentZo']},
      {name: 'Журнал учёта сотрудников', path:'usersListGreed', component:()=>import('@/views/grid/usersListGreed.vue'), menuView:true, accessGroup:[355,365]},
      {name: 'Online IL', path:'simple_demands', component:()=>import('@/views/grid/simple_demands'), menuView:true, accessGroup:[355,365,262,365,343,350 ], hideThisFor: ['canNotUseOnlineIl']}
    ],
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/index'),
    accessGroup: [355,713,763,389,281,350,262,343,99,149,493,757,827,495,309,273,823,272,435,425,365,],
  },
  {
    name:'Обучение',
    path:'/education',
    menuView:true,
    sort:190,
    component:()=>import('@/views/education/education')
  },
  {
    name:'Карта участков',
    path:'/yamaps',
    menuView:true,
    sort:200,
    component:()=>import('@/views/yandex/map'),
    beforeEnter: ifAuthenticated,
    accessGroup: [355,713,763,389,281,350,262,343,99,757,365,273, 365]
  },
  {
    name:'Согласование',
    path:'/acceptTransition',
    menuView:true,
    sort:205,
    component:()=>import('@/views/soglasovanie/soglasovanieMain.vue'),
    beforeEnter: ifAuthenticated,
    accessGroup: [355, 365, 389]
  },
  {
   name:'Оплата',
   path:'/payment',
   menuView:true,
   sort:210,
   component:()=>import('@/views/payment/routing')
  },
  {
    name: 'Телефонное взыскание',
    path: '/phonePunishment',
    menuView: true,
    sort: 230,
    component: () => import('@/views/index'),
    accessGroup:[355,516,757,365,495, 365],
    children: [
      {
        name: 'Телефонное взыскание Москва',
        path: 'finmoll-msk',
        menuView: true,
        sort: 220,
        component: () => import('@/views/grid/phonePunishment'),
        accessGroup:[355,516,757,365,495, 365],
      },
      {
        name: 'Детальное представление',
        path: 'loan-msk/:demandID',
        menuView: false,
        sort: 220,
        component: () => import('@/views/oneWindowView/oneWindowDetails'),
        accessGroup:[355,516,757,365, 365],
      },
      {
        name: 'Телефонное взыскание Новосибирск',
        path: 'finmoll-nsk',
        menuView: true,
        sort: 220,
        component: () => import('@/views/grid/phonePunishmentNsk'),
        accessGroup:[355,516,757,365,495, 365],
      },
      {
        name: 'Детальное представление Новосибирск',
        path: 'loan-nsk/:demandID',
        menuView: false,
        sort: 220,
        component: () => import('@/views/oneWindowView/oneWindowDetailsNsk'),
        accessGroup:[355,516,757,365, 365],
      },
    ]
  },
  {
    name: 'Верификация',
    path: '/verification',
    menuView: true,
    sort: 230,
    component: () => import('@/views/index'),
    accessGroup:[355,757,365,272,310,823,495,435],
    children: [
      {
        name: 'Верификация заявок PDL',
        path:'verificationPDL',
        component:()=>import('@/views/verification/verificationPDL'),
        menuView: true,
        accessGroup: [355,757,365,272,310,823,495, 365]
      },
      {
        name: 'Детальный просмотр заявки PDL',
        path:'loanPDL/:demand',
        component:()=>import('@/views/verification/verificationPDLdetail'),
        menuView: false,
        props: true,
        accessGroup: [355,757,365,272,310,823,495, 365]
      },
      {
        name: 'Верификация БП',
        path: 'verificationLoans',
        menuView: true,
        sort: 220,
        component: () => import('@/views/verification/VVerificationBaseProduct.vue'),
        accessGroup: [355,272,823,435, 365,],
      },
      {
        name: 'Верификация БП детальная',
        path:'loan/:demandId',
        component:()=>import('@/views/verification/VDetailBaseProduct.vue'),
        menuView: false,
        accessGroup: [355,272,823,435, 365,],
      },
    ]
  },
  {
    path:'/agentCCout',
    name:'Рабочее место агента по обзвону',
    menuView:true,
    sort: 240,
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/agentCCout/agentCCout.vue'),
    children:[
      {path:'grid',     name:'Реестр обзвона',         component:()=>import('@/views/agentCCout/grid.vue'),  menuView: true,},
      {path: 'import',  name: 'Загрузка реестра', component:()=>import('@/views/agentCCout/import.vue'), menuView: true,},
      {path: 'archive',  name: 'Архив', component:()=>import('@/views/agentCCout/archive.vue'), menuView: true,},
      {path: 'statistic',  name: 'Статистика', component:()=>import('@/views/agentCCout/statistic.vue'), menuView: true,},
      {path: 'instructions',  name: 'Инструкции', component:()=>import('@/views/agentCCout/instructions.vue'), menuView: true,},
    ],
    hideThisFor: ['masterZo','agentZo']
  },
  {
    path:'/payNumberCard',
    name:'Список карт оплаты',
    menuView: true,
    sort:250,
    beforeEnter:ifAuthenticated,
    component:()=>import('@/views/payCard/numbersPayCard.vue'),
    hideThisFor: ['agentZo']
  },
  {
    name: 'Займы',
    path: '/loans',
    menuView: true,
    sort: 250,
    children: [
      {name: 'Ввод договоров',     path:'autoInput',    component:()=>import('@/views/grid/contractsEntering'),    menuView: true,accessGroup: [355, 273, 757, 309, 365]},
    ],
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/index'),
    accessGroup: [355, 273, 309, 365]
  },
  {
    name: 'Бух учёт',
    path: '/bookkeeping',
    menuView: true,
    sort: 260,
    children: [
      {name: 'Проверки полотна',     path:'checks',    component:()=>import('@/views/bookkeeping/proverki-polotna-main-window'),    menuView: true,accessGroup: [355, 365, 832, 493, 99, 669]},
      {name: 'Отчетность по закрытию',     path:'closure-reporting',    component:()=>import('@/views/bookkeeping/closure-reporting'),    menuView: true,accessGroup: [355, 365, 832, 493, 309, 273, 99, 669, 830]},
    ],
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/index'),
    accessGroup: [355, 365, 832, 493, 309, 273, 99, 669, 830],
    hideThisFor: ['canNotUseBookkeeping']
  },
  {
    name: 'Администрирование',
    path: '/administration',
    menuView: true,
    sort: 270,
    children: [
      {name: 'Управление объектами',     path:'portalObjects',    component:()=>import('@/views/administration/portalObjects.vue'),    menuView: true,accessGroup: [355, 365]},
      {name: 'Управление группами',     path:'groupsControl',    component:()=>import('@/views/administration/groupsControl.vue'),    menuView: true,accessGroup: [355, 365]},
      {name: 'Управление ролями',     path:'rolesControl',    component:()=>import('@/views/administration/rolesControl.vue'),    menuView: true,accessGroup: [355, 365]},
    ],
    beforeEnter: ifAuthenticated,
    component:()=>import('@/views/index'),
    accessGroup: [355, 365],
  },
  // {
  //   name: 'Видео звонок',
  //   path: '/video_call/:demand',
  //   menuView: true,
  //   sort: 250,
  //   component:() => import('@/views/webRtc/VWebRtc.vue'),
  //   props: true,
  // },
  {
    path: '*',
    name: 'error404',
    component: () => import('@/views/404'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

/**
 * Глобальный гейтинг по доступам (web-объектам пользователя).
 * - авторизацию проверяет per-route ifAuthenticated, здесь только доступы авторизованного;
 * - массив доступов грузится один раз за сессию (ensureLoaded с кэшем) - покрывает старт и F5;
 * - защищаемый роут объявляет meta: { accessObjId: <id> }; роуты без него не затрагиваются.
 */
router.beforeEach(async (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  const requiredId = to.meta && to.meta.accessObjId;
  try {
    await getAccessArray.ensureLoaded();
  } catch (e) {
    // сбой загрузки доступов: защищённый роут ограничиваем, негейтед - пускаем (без массового локаута)
    if (requiredId) {
      alert(getAccessArray.ACCESS_LOAD_ERROR_TAG + ' ограничен доступ, попробуйте позже или сообщите на support');
      next(to.path === '/' ? false : '/');
      return;
    }
    next();
    return;
  }
  if (requiredId && !store.getters.accessSearch(requiredId)) {
    alert('У вас нет доступа к этому разделу');
    next(to.path === '/' ? false : '/');
    return;
  }
  next();
});

router.afterEach((to, from) => {
  let strTitle = to.name;

  if (to.params !== undefined && to.params.demand !== undefined){
    strTitle += ' №' + to.params.demand;
  }
  document.title = strTitle;




  $myApi.singleRequest({
      action:'metrik_pageHit',
      value:{
        fromPage:from.fullPath,
        toPage:to.fullPath,
      },
    }).then(res=>{
      if (res != undefined) {
        res['asd'] = 'asd';
      }
    }).catch(res=>{
      if (res != undefined) {
        res['asd'] = 'asd';
      }
    });
});

export default router
